import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 150,
    damping: 25,
    restDelta: 0.001
  });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#B99A5B]/80 via-[#E5C47E] to-[#B99A5B] origin-left z-[60] pointer-events-none shadow-[0_0_8px_rgba(185,154,91,0.5)]"
    />
  );
};

export default ScrollProgress;
